import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { createContext, useReducer, useMemo, useEffect, useContext } from 'react';
import { PNGlobalContext, REFRESH_PN_DATA } from '@mummssoftware/global-context/PNGlobalContext';
import { GlobalContext, SET_GLOBAL_PATIENT } from '@mummssoftware/global-context/GlobalContext';
import { initListener } from './PimMessenger';
import { COMPLETED, IDG_ROLE_ATTESTATION_DONE_FROM_PIM, MESSAGE_DASHBOARD_DEMOGRAPHICS_UPDATED_FOM_PIM, SET_IDG_RENDER_INSTRUCTIONS } from './constants';
/* Context for managing messaging to and from PIM */

const initialState = {
  attestationsDone: [],
  refreshPatientHeader: 0,
  idgRenderInstructions: null
};
const initPimMessagingContext = {
  attestationsDone: [],
  refreshPatientHeader: 0,
  idgRenderInstructions: null
};
export const PimMessagingContextReducer = (state, action) => {
  let newState = _objectSpread({}, state);

  switch (action.type) {
    case IDG_ROLE_ATTESTATION_DONE_FROM_PIM:
      newState.attestationsDone = [...state.attestationsDone.concat(action.payload)];

      if (String(action.payload.messagePayload.idgdiscussionStatus).toUpperCase() === COMPLETED) {
        newState.idgRenderInstructions = action.payload.messagePayload;
      }

      break;

    case MESSAGE_DASHBOARD_DEMOGRAPHICS_UPDATED_FOM_PIM:
      newState.refreshPatientHeader++;
      break;

    case SET_IDG_RENDER_INSTRUCTIONS:
      newState.idgRenderInstructions = action.payload;
      break;

    default:
      newState = state;
      break;
  }

  return newState;
};
export const PimMessagingContext = /*#__PURE__*/createContext(initPimMessagingContext);
export const PimMessagingDispatchContext = /*#__PURE__*/createContext({});
export const PimMessagingContextConsumer = PimMessagingContext.Consumer;
export const PimMessagingDispatchContextConsumer = PimMessagingDispatchContext.Consumer;
export const PimMessagingContextProvider = ({
  children,
  pim,
  patient,
  agency
}) => {
  const [// eslint-disable-next-line no-empty-pattern
  {
    attestationsDone,
    refreshPatientHeader,
    idgRenderInstructions
  }, dispatch] = useReducer(PimMessagingContextReducer, initialState);
  const {
    dispatchPN
  } = useContext(PNGlobalContext);
  const globalContext = useContext(GlobalContext);

  const getPatient = async () => {
    const patientRes = await Promise.resolve(pim.getPatientHeader(patient.patientNumber, agency));
    globalContext.dispatch({
      type: SET_GLOBAL_PATIENT,
      payload: patientRes
    });
  };

  useEffect(() => {
    initListener(dispatch);
  }, []);
  useEffect(() => {
    if (attestationsDone.length) {
      dispatchPN({
        type: REFRESH_PN_DATA,
        payload: {
          scroll: true
        }
      });
    }
  }, [attestationsDone.length]); // trigger patientHeader and user info in dashboard

  useEffect(() => {
    // update patient global
    if (refreshPatientHeader && patient) {
      getPatient();
    }
  }, [refreshPatientHeader]);
  const context = useMemo(() => ({
    attestationsDone,
    refreshPatientHeader,
    idgRenderInstructions,
    dispatch
  }), [attestationsDone, refreshPatientHeader, idgRenderInstructions, dispatch]);
  return /*#__PURE__*/React.createElement(PimMessagingContext.Provider, {
    value: context
  }, children);
};
export function withPimMessagingContext(Component) {
  return function contextComponent(props) {
    return /*#__PURE__*/React.createElement(PimMessagingContextConsumer, null, context => /*#__PURE__*/React.createElement(PimMessagingDispatchContextConsumer, null, dispatchContext => /*#__PURE__*/React.createElement(Component, _extends({}, props, context, dispatchContext))));
  };
}
export default PimMessagingContext;